"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4135],{

/***/ 24135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SectionHeaderCount_SectionHeaderCount; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
;// CONCATENATED MODULE: ./src/views/Project/components/SectionHeaderCount/SectionHeaderCount.tsx



var parse = __webpack_require__(30488);
var SectionHeaderCount = function(param) {
    var count = param.count, title = param.title, subTitle = param.subTitle, body = param.body, isSecondPage = param.isSecondPage, isBreakTitle = param.isBreakTitle;
    (0,react.useLayoutEffect)(function() {
        window.requestAnimationFrame(function() {
            var tl = gsap/* default.timeline */.ZP.timeline({
                scrollTrigger: {
                    trigger: "._projectLandingTrigger",
                    start: "top 85%"
                },
                defaults: {
                    duration: 1.4
                }
            });
            tl.to("._projectNumber", {
                opacity: 1,
                x: 0,
                delay: 0.2
            }, "start").to("._projectDec", {
                opacity: 1,
                x: 0,
                delay: 0.2
            }, "start");
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col px-[2.5rem] lg:px-0 lg:mb-0 mb-[3.57143rem] md:flex-row md:items-center _projectLandingTrigger",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative lg:flex-[0_0_auto]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-0 relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desktop:text-[32.14286rem] md:text-[21.42857rem] text-[15.71429rem] leading-[.7] text-[#F5F5F5] opacity-0 -translate-x-8 _projectNumber font-[800] z-[-1]",
                            children: count
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute left-[1.92857rem] bottom-0 md:left-[3.85714rem] md:top-[50%] md:translate-y-[-50%] md:bottom-auto tracking-[1.42857em]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-[1.57143rem] leading-[1.22727em] font-bold text-left tracking-normal text-[#131313] my-[0.83em]",
                                children: [
                                    title,
                                    isBreakTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            isBreakTitle
                                        ]
                                    }) : null,
                                    subTitle !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        className: "font-normal",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            subTitle
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative px-[1.92857rem] md:px-0 md:pl-[0.35714rem] desktop:pr-[14.28571rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[#4a4a4a] text-[1.28571rem] lg:text-[1.57143rem] leading-[1.22222em] lg:leading-[27px] mt-[1em] lg:my-[1em] opacity-0 translate-x-8 _projectDec",
                    children: parse(body ? body : "")
                })
            })
        ]
    });
};
/* harmony default export */ var SectionHeaderCount_SectionHeaderCount = (SectionHeaderCount);

;// CONCATENATED MODULE: ./src/views/Project/components/SectionHeaderCount/index.ts




/***/ })

}]);